/*
  Like the standard react-redux connect, but allows an object shorthand
  for `mapStateToProps`, where the keys are the prop names and the values
  are selectors that take the state and props as arguments.
*/

import { Dispatch } from "react";
import { connect as reactReduxConnect } from "react-redux";
import type { Action, AnyAction } from "redux";

type PropSelector = (state: any, props?: Record<string, any>) => any;
type MapStateToProps =
  | ((state: any, props?: Record<string, any>) => Record<string, any>)
  | Record<string, PropSelector>;
type MapDispatchToProps =
  | ((dispatch: Dispatch<Action>, props?: Record<string, unknown>) => Record<string, unknown>)
  | Record<string, (...args: unknown[]) => AnyAction>;

export default function connect(mapStateToProps: MapStateToProps, mapDispatchToProps?: MapDispatchToProps) {
  if (typeof mapStateToProps !== "function") {
    const propSelectors = mapStateToProps;
    mapStateToProps = function (state: unknown, props?: Record<string, unknown>) {
      const callSelector = (selector: PropSelector) => selector(state, props);
      return Object.entries(propSelectors).reduce((accumulator: Record<string, unknown>, [k, v]) => {
        accumulator[k] = callSelector(v);
        return accumulator;
      }, {});
    };
  }

  return reactReduxConnect(mapStateToProps, mapDispatchToProps);
}
